function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useRef, useState } from 'react';
import cn from 'classnames';
import { isObject } from 'lodash-es';
import { Row, TextButton, Tooltip } from 'seagull';
import { Edit2Liner24 } from 'seagull/icons';
import { BundlePriceEditor } from "../../BundlePriceEditor/BundlePriceEditor";
import { ServicePriceEditor } from "../../ServicePriceEditor/ServicePriceEditor";
import ServicePriceEditorV2 from "../../ServicePriceEditorV2/ServicePriceEditorV2";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { serviceModel } from "../../../models";
import { isOneTimeInStages } from "../../../models/service-billing";
import PriceDisplay from "../PriceDisplay/PriceDisplay";
import { getPriceDisplayProps } from "../ServiceDetails.utils";
import styles from "./EditablePrice.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function EditablePrice(props) {
  const {
    serviceWithChanges,
    service,
    testid,
    disableEditCost,
    isReadOnly,
    showDiscountError,
    onCostChange,
    onChangeService
  } = props;
  const [priceEditorOpen, setPriceEditorOpen] = useState(false);
  const editorButtonRef = useRef(null);
  const {
    SERVICE_TEMPLATE_BUNDLE,
    INLINE_EDIT_SERVICE_PRICING
  } = useFeatureFlags();
  const isBundle = Boolean(SERVICE_TEMPLATE_BUNDLE && serviceModel.isBundle(serviceWithChanges));
  function tooltip() {
    if (showDiscountError) {
      return {
        'data-testid': 'discount-error-tooltip',
        title: "When the billing trigger is set to 'In stages', the discount can only be applied as a percentage"
      };
    } else if (isObject(disableEditCost)) {
      return {
        'data-testid': 'disabled-tooltip',
        title: disableEditCost.disabledTooltip
      };
    } else {
      return undefined;
    }
  }
  const isDisabled = isReadOnly || !!disableEditCost;
  const PriceButton = INLINE_EDIT_SERVICE_PRICING ? /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, tooltip() || {
    title: ''
  }), {}, {
    children: /*#__PURE__*/_jsx("div", {
      ref: editorButtonRef,
      role: "button",
      "data-testid": testid + 'inline-edit-price-button',
      "data-error": showDiscountError.toString(),
      "aria-disabled": isDisabled,
      onClick: !isDisabled ? () => setPriceEditorOpen(true) : undefined,
      className: cn(styles.priceButtonContainer, {
        [styles.clickable]: !isDisabled
      }),
      children: /*#__PURE__*/_jsxs(Row, {
        gap: 8,
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(PriceDisplay, _objectSpread(_objectSpread({}, getPriceDisplayProps(serviceWithChanges)), {}, {
          error: showDiscountError,
          "data-testid": testid + 'inline-edit-'
        })), /*#__PURE__*/_jsx(Row, {
          className: styles.editIconButton,
          "data-testid": testid + 'inline-price-edit',
          children: /*#__PURE__*/_jsx(Edit2Liner24, {})
        })]
      })
    })
  })) : /*#__PURE__*/_jsx(TextButton, {
    onClick: () => setPriceEditorOpen(true),
    disabled: isReadOnly || !!disableEditCost,
    tooltip: tooltip(),
    underline: "none",
    skin: showDiscountError ? 'error' : 'secondary',
    suffixIcon: /*#__PURE__*/_jsx(Edit2Liner24, {}),
    ref: editorButtonRef,
    "data-error": showDiscountError,
    "data-testid": testid + 'inline-edit-price-button',
    children: /*#__PURE__*/_jsx(PriceDisplay, _objectSpread(_objectSpread({}, getPriceDisplayProps(serviceWithChanges)), {}, {
      error: showDiscountError,
      "data-testid": testid + 'inline-edit-'
    }))
  });
  const PriceEditor = INLINE_EDIT_SERVICE_PRICING ? /*#__PURE__*/_jsx(ServicePriceEditorV2, {
    onServiceChange: onChangeService,
    service: serviceWithChanges,
    editorAnchor: editorButtonRef.current,
    isOpen: priceEditorOpen,
    setIsOpen: setPriceEditorOpen
  }) : isBundle ? /*#__PURE__*/_jsx(BundlePriceEditor, {
    serviceWithChanges: serviceWithChanges,
    service: service,
    editorAnchor: editorButtonRef.current,
    isOpen: priceEditorOpen,
    setIsOpen: setPriceEditorOpen,
    onChangeService: onChangeService
  }) : /*#__PURE__*/_jsx(ServicePriceEditor, {
    isBillInStages: isOneTimeInStages(serviceWithChanges.billing),
    cost: serviceWithChanges.cost,
    editorAnchor: editorButtonRef.current,
    isOpen: priceEditorOpen,
    setIsOpen: setPriceEditorOpen,
    onCostChange: onCostChange
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [PriceButton, PriceEditor]
  });
}